"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TreeItem", {
    enumerable: true,
    get: function() {
        return TreeItem;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTreeItem = require("./useTreeItem");
const _renderTreeItem = require("./renderTreeItem");
const _useTreeItemStylesstyles = require("./useTreeItemStyles.styles");
const _useTreeItemContextValues = require("./useTreeItemContextValues");
const TreeItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTreeItem.useTreeItem_unstable)(props, ref);
    (0, _useTreeItemStylesstyles.useTreeItemStyles_unstable)(state);
    const contextValues = (0, _useTreeItemContextValues.useTreeItemContextValues_unstable)(state);
    return (0, _renderTreeItem.renderTreeItem_unstable)(state, contextValues);
});
TreeItem.displayName = 'TreeItem';
